/**
 * Forced-choice cart upsell.
 *
 * Each upsell row has a checkbox whose checked state is rendered server-side from the current cart.
 * Checking the box adds the product (first available variant) to the cart; unchecking removes it.
 *
 * - On the cart PAGE the theme re-renders line items via a full reload, so we reload after the change.
 * - In the cart DRAWER we use the theme's bundled-sections mechanism and dispatch `cart:change`
 *   so the drawer (and its freshly rendered checkboxes) update in place.
 */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function isCartPage() {
    return !!(
      window.themeVariables &&
      window.themeVariables.settings &&
      window.themeVariables.settings.pageType === 'cart'
    );
  }

  function getBundledSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      })
    );
    return sections;
  }

  function dispatchCartChange(cart, baseEvent) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: baseEvent, cart: cart }
      })
    );
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function findLineKey(cart, handle, variantId) {
    var vId = Number(variantId);
    var match = (cart.items || []).find(function (item) {
      return item.variant_id === vId || item.handle === handle;
    });
    return match ? match.key : null;
  }

  function addProduct(variantId, sections) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: sections.join(',') })
    }).then(function (res) {
      if (!res.ok) throw new Error('Unable to add product');
      return res.json();
    });
  }

  function removeLine(lineKey, sections) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0, sections: sections.join(',') })
    }).then(function (res) {
      if (!res.ok) throw new Error('Unable to remove product');
      return res.json();
    });
  }

  function onToggle(checkbox) {
    if (busy) return;

    var item = checkbox.closest('[data-upsell-item]');
    if (!item) return;

    var variantId = item.getAttribute('data-variant-id');
    var handle = item.getAttribute('data-product-handle');
    var shouldAdd = checkbox.checked;

    busy = true;
    checkbox.disabled = true;
    item.classList.add('is-loading');

    var onCartPage = isCartPage();
    var sections = onCartPage ? [] : getBundledSections();

    var work;

    if (shouldAdd) {
      work = addProduct(variantId, sections).then(function (addResponse) {
        if (onCartPage) {
          window.location.reload();
          return null;
        }
        return getCart().then(function (cart) {
          cart.sections = addResponse.sections;
          dispatchCartChange(cart, 'variant:add');
        });
      });
    } else {
      work = getCart().then(function (cart) {
        var key = findLineKey(cart, handle, variantId);
        if (!key) {
          // Already gone; nothing to remove.
          if (onCartPage) {
            window.location.reload();
            return null;
          }
          return Promise.resolve();
        }
        return removeLine(key, sections).then(function (updatedCart) {
          if (onCartPage) {
            window.location.reload();
            return null;
          }
          dispatchCartChange(updatedCart, 'line-item:change');
        });
      });
    }

    work
      .catch(function (error) {
        // Revert the checkbox so it reflects the real cart state.
        checkbox.checked = !shouldAdd;
        item.classList.toggle('is-selected', checkbox.checked);
        if (window.console && console.error) console.error('[cart-upsell]', error);
      })
      .then(function () {
        busy = false;
        checkbox.disabled = false;
        item.classList.remove('is-loading');
      });
  }

  function bind(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var checkboxes = container.querySelectorAll('[data-upsell-checkbox]');
    Array.prototype.forEach.call(checkboxes, function (checkbox) {
      if (checkbox.__upsellBound) return;
      checkbox.__upsellBound = true;
      checkbox.addEventListener('change', function () {
        onToggle(checkbox);
      });
    });
  }

  function init() {
    bind(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The cart drawer replaces its contents on every update; re-bind the fresh checkboxes.
  document.addEventListener('cart-drawer:refreshed', init);
})();
